import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ImageCarousel } from './components/ImageCarousel';
import { AlertBanner } from './components/AlertBanner';
import { RealitySection } from './components/RealitySection';
import { NewRealitySection } from './components/NewRealitySection';
import { ModulesSection } from './components/ModulesSection';
import { TestimonialsCarousel } from './components/TestimonialsCarousel';
import { StatsBanner } from './components/StatsBanner';
import { BonusSection } from './components/BonusSection';
import { ValueCTA } from './components/ValueCTA';
import { TestimonialsText } from './components/TestimonialsText';
import { SystemPreview } from './components/SystemPreview';
import { PricingSection } from './components/PricingSection';
import { CtaSection } from './components/CtaSection';
import { GuaranteeAndFaq } from './components/GuaranteeAndFaq';
import { CommunitySection } from './components/CommunitySection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ImageCarousel data-id="element-2" />
      <AlertBanner data-id="element-3" />
      <RealitySection data-id="element-4" />
      <NewRealitySection data-id="element-5" />
      <ModulesSection data-id="element-6" />
      <TestimonialsCarousel data-id="element-7" />
      <StatsBanner data-id="element-8" />
      <BonusSection data-id="element-9" />
      <ValueCTA data-id="element-10" />
      <TestimonialsText data-id="element-11" />
      <SystemPreview data-id="element-12" />
      <PricingSection data-id="element-13" />
      <CtaSection data-id="element-14" />
      <GuaranteeAndFaq data-id="element-15" />
      <CommunitySection data-id="element-16" />
      <FinalCtaSection data-id="element-17" />
      <FloatingCTA data-id="element-18" />
    </div>;
}